<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    Atlas Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Atlas Reports
                </base-button>
                <a class="dropdown-item" @click.prevent="setCurrentProfile('atlas_consolidated_pullout_reports', null)" href="#">Consolidated Pull Out Report</a>
            </base-dropdown>
        </base-header>
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col" v-if="currentProfile == 'consolidated_pull_out_reports' || currentProfile == 'atlas_consolidated_pullout_reports' || currentProfile == 'atlas_consolidated_pull_out_reports'">
                    <AtlasConsolidatedPulloutReport :access_rights="accessRights"></AtlasConsolidatedPulloutReport>
                </div>
                <div class="col" v-if="currentProfile == 'consolidated_transfer_in_reports' || currentProfile == 'atlas_consolidated_transfer_in_reports'">
                    <AtlasConsolidatedTransferInReport :access_rights="accessRights"></AtlasConsolidatedTransferInReport>
                </div>
                <div class="col" v-if="currentProfile == 'consolidated_transfer_out_reports' || currentProfile == 'atlas_consolidated_transfer_out_reports'">
                    <AtlasConsolidatedTransferOutReport :access_rights="accessRights"></AtlasConsolidatedTransferOutReport>
                </div>
                <div class="col" v-if="currentProfile == 'consolidated_stock_request_reports' || currentProfile == 'atlas_consolidated_stock_request_reports'">
                    <AtlasConsolidatedStockRequestReport :access_rights="accessRights"></AtlasConsolidatedStockRequestReport>
                </div>
                <div class="col" v-if="currentProfile == 'consolidated_physical_count_reports' || currentProfile == 'atlas_consolidated_physical_count_reports'">
                    <AtlasConsolidatedPhysicalCountReport :access_rights="accessRights"></AtlasConsolidatedPhysicalCountReport>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AtlasConsolidatedPulloutReport from './AtlasConsolidatedPulloutReport.vue';
    import AtlasConsolidatedTransferInReport from './AtlasConsolidatedTransferInReport.vue';
    import AtlasConsolidatedTransferOutReport from './AtlasConsolidatedTransferOutReport.vue';
    import AtlasConsolidatedStockRequestReport from './AtlasConsolidatedStockRequestReport.vue';
    import AtlasConsolidatedPhysicalCountReport from './AtlasConsolidatedPhysicalCountReport.vue';

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        components: {
            AtlasConsolidatedPulloutReport,
            AtlasConsolidatedTransferInReport,
            AtlasConsolidatedTransferOutReport,
            AtlasConsolidatedStockRequestReport,
            AtlasConsolidatedPhysicalCountReport,
        },
        mounted: async function () {
            var component_x = this;

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);

            try {
                var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=ATLREP&status=A', null, null)
                if(categoryId && categoryId[0] != undefined){
                    component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
                    if (component_x.activeModules.length > 0) {
                        var profile = _.snakeCase(component_x.activeModules[0].name)
                        component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                    } else {
                        component_x.setCurrentProfile('atlas_consolidated_pullout_reports', null);
                    }
                } else {
                    component_x.setCurrentProfile('atlas_consolidated_pullout_reports', null);
                }
            } catch(e) {
                console.log('Atlas Reports: category not found, loading default report', e)
                component_x.setCurrentProfile('atlas_consolidated_pullout_reports', null);
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                if(id) {
                    var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                    if (_.isEmpty(accessRightsRequest.access_rights) == false){
                        this.accessRights = accessRightsRequest.access_rights[id]
                    } else {
                        this.accessRights = []
                    }
                } else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>
